module.exports = __webpack_public_path__ + "img/Man-7.f39faf9c.svg";